import { render, staticRenderFns } from "./DirectFlightFilter.vue?vue&type=template&id=f2663db2&scoped=true&"
import script from "./DirectFlightFilter.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DirectFlightFilter.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./DirectFlightFilter.vue?vue&type=style&index=0&id=f2663db2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2663db2",
  null
  
)

export default component.exports